import { render, staticRenderFns } from "./AffiliateLinkDisplay.vue?vue&type=template&id=1c906b5a&"
import script from "./AffiliateLinkDisplay.vue?vue&type=script&lang=js&"
export * from "./AffiliateLinkDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports